import { Link } from 'react-router-dom';
import Logo from '../shared/Logo';

/**
 * Footer - Lucky Number Design System
 *
 * Midnight background, cream text, petrol link accents.
 */
export default function Footer({ className = '' }) {
  return (
    <footer className={`bg-midnight border-t border-midnight-lighter ${className}`}>
      <div className="page-container py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-1">
            <div className="mb-4">
              <Logo size="md" />
            </div>
            <p className="text-cream/50 text-sm">
              A new way to buy and sell locally in Ireland.
            </p>
          </div>

          {/* Browse */}
          <div>
            <h4 className="font-bold uppercase tracking-wider text-cream text-sm mb-4">Browse</h4>
            <ul className="space-y-2 text-cream/50 text-sm">
              <li>
                <Link to="/browse" className="hover:text-primary transition-colors">
                  All Competitions
                </Link>
              </li>
              <li>
                <Link to="/browse?category=electronics" className="hover:text-primary transition-colors">
                  Electronics
                </Link>
              </li>
              <li>
                <Link to="/browse?category=gaming" className="hover:text-primary transition-colors">
                  Gaming
                </Link>
              </li>
              <li>
                <Link to="/browse?category=fashion" className="hover:text-primary transition-colors">
                  Fashion
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-bold uppercase tracking-wider text-cream text-sm mb-4">Support</h4>
            <ul className="space-y-2 text-cream/50 text-sm">
              <li>
                <Link to="/how-it-works" className="hover:text-primary transition-colors">
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/how-it-works#faq" className="hover:text-primary transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <a href="mailto:support@raflr.ie" className="hover:text-primary transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold uppercase tracking-wider text-cream text-sm mb-4">Legal</h4>
            <ul className="space-y-2 text-cream/50 text-sm">
              <li>
                <Link to="/terms" className="hover:text-primary transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/privacy#cookies" className="hover:text-primary transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-midnight-lighter mt-8 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-cream/40 text-sm">
            &copy; {new Date().getFullYear()} Raflr. All rights reserved.
          </p>
          <p className="text-cream/30 text-xs">
            Made in Ireland
          </p>
        </div>
      </div>
    </footer>
  );
}
